module.exports = __webpack_public_path__ + "static/halo.4462d903.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/network/halo.png
// module id = 236
// module chunks = 0